(function () {
  const defaultI18n = {
    send: 'Submit',
    sending: 'Submitting…',
    success: 'Your review was received.',
    submitError: 'Your review could not be submitted. Please try again.',
    validationError: 'Please fill in all required fields.',
  };

  const parseI18n = (modal) => {
    const node = modal.querySelector('[data-review-submit-i18n]');
    if (!node) {
      return { ...defaultI18n };
    }
    try {
      return { ...defaultI18n, ...JSON.parse(node.textContent) };
    } catch (error) {
      return { ...defaultI18n };
    }
  };

  const getHoneypotValue = (formData) => {
    return String(formData.get('review_bot_check') || formData.get('website') || '').trim();
  };

  const resolveStoreShop = (form, modal) => {
    const shopInput = form ? form.querySelector('input[name="shop"]') : null;
    const datasetShop = modal ? modal.dataset.reviewSubmitShop : '';
    const shop =
      typeof window.jokerStorefrontShop === 'function'
        ? window.jokerStorefrontShop(datasetShop)
        : '';
    if (shop && shopInput) {
      shopInput.value = shop;
    }
    return shop;
  };

  const buildSubmitUrl = (apiBase, shop) => {
    const base = apiBase.replace(/\/$/, '');
    const shopParam = encodeURIComponent(shop);
    return `${base}/api/storefront/submit-comment?shop=${shopParam}`;
  };

  const isImageStorageConfigError = (message) => {
    const text = String(message || '').toLowerCase();
    return (
      text.includes('yapılandırılmamış') ||
      text.includes('not configured') ||
      (text.includes('storage') && text.includes('upload'))
    );
  };

  const postJsonComment = async (apiBase, shop, payload, fallbackError) => {
    const response = await fetch(buildSubmitUrl(apiBase, shop), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data.error || fallbackError);
    }
    return data;
  };

  const getModalById = (id) => {
    if (!id) {
      return null;
    }
    return document.getElementById(id);
  };

  const openModal = (modal) => {
    if (!modal) {
      return;
    }
    bindModal(modal);
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('review-submit-open');
    const loginButton = modal.querySelector('.review-submit__login-btn');
    const focusTarget =
      loginButton ||
      modal.querySelector('[data-review-submit-star]') ||
      modal.querySelector('.review-submit__input, .review-submit__select, .review-submit__textarea');
    if (focusTarget) {
      focusTarget.focus();
    }
  };

  const closeModal = (modal) => {
    if (!modal) {
      return;
    }
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('review-submit-open');
    const feedback = modal.querySelector('[data-review-submit-feedback]');
    if (feedback) {
      feedback.hidden = true;
      feedback.textContent = '';
      feedback.classList.remove('is-success');
    }
  };

  const setFeedback = (modal, message, isSuccess) => {
    const feedback = modal.querySelector('[data-review-submit-feedback]');
    if (!feedback) {
      return;
    }
    feedback.textContent = message || '';
    feedback.classList.toggle('is-success', Boolean(isSuccess));
    feedback.hidden = !message;
    if (message) {
      feedback.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  };

  const validateFormData = (formData) => {
    const firstName = String(formData.get('firstName') || '').trim();
    const lastName = String(formData.get('lastName') || '').trim();
    const authorEmail = String(formData.get('authorEmail') || '').trim();
    const ratingValue = Number(formData.get('rating'));
    const body = String(formData.get('body') || '').trim();
    if (!firstName || !lastName || !authorEmail || !body) {
      return false;
    }
    if (!Number.isFinite(ratingValue) || ratingValue < 1 || ratingValue > 5) {
      return false;
    }
    return true;
  };

  const setStarRating = (form, value) => {
    const starsWrap = form.querySelector('[data-review-submit-stars]');
    if (!starsWrap) {
      return;
    }
    const hidden = form.querySelector('[data-review-submit-rating-input]');
    const buttons = starsWrap.querySelectorAll('[data-review-submit-star]');
    const rating = Number(value) || 0;
    if (hidden) {
      hidden.value = rating > 0 ? String(rating) : '';
    }
    buttons.forEach((btn) => {
      const starValue = Number(btn.dataset.reviewSubmitStar);
      btn.classList.toggle('is-active', rating > 0 && starValue <= rating);
      btn.setAttribute('aria-checked', starValue === rating ? 'true' : 'false');
    });
  };

  const resetProductFormUi = (form) => {
    setStarRating(form, 0);
    const fileInput = form.querySelector('[data-review-submit-file-input]');
    const fileName = form.querySelector('[data-review-submit-file-name]');
    if (fileInput) {
      fileInput.value = '';
    }
    if (fileName) {
      const emptyLabel = fileName.dataset.reviewSubmitFileEmpty || '';
      fileName.textContent = emptyLabel;
    }
  };

  const bindStarRating = (form) => {
    const starsWrap = form.querySelector('[data-review-submit-stars]');
    if (!starsWrap || starsWrap.dataset.reviewSubmitStarsBound === 'true') {
      return;
    }
    const buttons = starsWrap.querySelectorAll('[data-review-submit-star]');
    let hoverValue = 0;

    const applyDisplay = (value) => {
      const display = hoverValue || value;
      buttons.forEach((btn) => {
        const starValue = Number(btn.dataset.reviewSubmitStar);
        btn.classList.toggle('is-active', display > 0 && starValue <= display);
      });
    };

    buttons.forEach((btn) => {
      const starValue = Number(btn.dataset.reviewSubmitStar);
      btn.addEventListener('click', () => {
        setStarRating(form, starValue);
      });
      btn.addEventListener('mouseenter', () => {
        hoverValue = starValue;
        applyDisplay(Number(form.querySelector('[data-review-submit-rating-input]')?.value || 0));
      });
      btn.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setStarRating(form, starValue);
        }
      });
    });

    starsWrap.addEventListener('mouseleave', () => {
      hoverValue = 0;
      applyDisplay(Number(form.querySelector('[data-review-submit-rating-input]')?.value || 0));
    });

    setStarRating(form, 0);
    starsWrap.dataset.reviewSubmitStarsBound = 'true';
  };

  const bindFileInput = (form) => {
    const fileInput = form.querySelector('[data-review-submit-file-input]');
    const trigger = form.querySelector('[data-review-submit-file-trigger]');
    const fileName = form.querySelector('[data-review-submit-file-name]');
    if (!fileInput || fileInput.dataset.reviewSubmitFileBound === 'true') {
      return;
    }
    const emptyLabel = fileName ? fileName.dataset.reviewSubmitFileEmpty || fileName.textContent : '';

    if (trigger) {
      trigger.addEventListener('click', () => {
        fileInput.click();
      });
    }

    fileInput.addEventListener('change', () => {
      if (!fileName) {
        return;
      }
      const file = fileInput.files && fileInput.files[0];
      fileName.textContent = file ? file.name : emptyLabel;
    });

    fileInput.dataset.reviewSubmitFileBound = 'true';
  };

  const buildJsonPayload = (form, modal) => {
    const shop = resolveStoreShop(form, modal);
    const formData = new FormData(form);
    const honeypot = getHoneypotValue(formData);
    if (honeypot) {
      return null;
    }
    const type = String(formData.get('type') || modal.dataset.reviewSubmitType || '').trim();
    const firstName = String(formData.get('firstName') || '').trim();
    const lastName = String(formData.get('lastName') || '').trim();
    const authorEmail = String(formData.get('authorEmail') || '').trim();
    const ratingValue = Number(formData.get('rating'));
    const body = String(formData.get('body') || '').trim();
    const showAuthorName = formData.get('showAuthorName') === 'on';

    if (!shop || !type || !firstName || !lastName || !authorEmail || !body) {
      return { invalid: true };
    }

    if (!Number.isFinite(ratingValue) || ratingValue < 1 || ratingValue > 5) {
      return { invalid: true };
    }

    const rating = ratingValue;

    const payload = {
      shop,
      type,
      firstName,
      lastName,
      authorEmail,
      rating,
      body,
      showAuthorName,
    };

    if (type === 'PRODUCT') {
      payload.productId = String(formData.get('productId') || modal.dataset.reviewSubmitProductId || '').trim();
      payload.productTitle = String(formData.get('productTitle') || modal.dataset.reviewSubmitProductTitle || '').trim();
      if (!payload.productId || !payload.productTitle) {
        return { invalid: true };
      }
    }

    return payload;
  };

  const submitForm = async (modal, form, i18n) => {
    const apiBase = modal.dataset.reviewSubmitApi || '';
    const fileInput = form.querySelector('input[type="file"][name="image"]');
    const hasFile = fileInput && fileInput.files && fileInput.files.length > 0;
    const submitButton = form.querySelector('[data-review-submit-button]');
    const defaultLabel = i18n.send || submitButton?.textContent || '';

    const shop = resolveStoreShop(form, modal);
    if (!shop) {
      setFeedback(modal, i18n.submitError, false);
      return;
    }

    if (hasFile) {
      const formData = new FormData(form);
      formData.set('shop', shop);
      const honeypot = getHoneypotValue(formData);
      if (honeypot) {
        setFeedback(modal, i18n.success, true);
        form.reset();
        resetProductFormUi(form);
        return;
      }

      if (!validateFormData(formData)) {
        setFeedback(modal, i18n.validationError, false);
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = i18n.sending || defaultLabel;
      }

      try {
        const response = await fetch(buildSubmitUrl(apiBase, shop), {
          method: 'POST',
          body: formData,
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          const errMsg = data.error || i18n.submitError;
          if (isImageStorageConfigError(errMsg)) {
            const payload = buildJsonPayload(form, modal);
            if (payload && !payload.invalid) {
              const jsonData = await postJsonComment(apiBase, shop, payload, i18n.submitError);
              const baseMsg = jsonData.message || i18n.success || '';
              const extra = i18n.successWithoutImage ? ` ${i18n.successWithoutImage}` : '';
              setFeedback(modal, `${baseMsg}${extra}`.trim(), true);
              form.reset();
              resetProductFormUi(form);
              return;
            }
          }
          throw new Error(errMsg);
        }
        setFeedback(modal, data.message || i18n.success || '', true);
        form.reset();
        resetProductFormUi(form);
      } catch (error) {
        setFeedback(modal, error.message || i18n.submitError || '', false);
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = defaultLabel;
        }
      }
      return;
    }

    const formDataCheck = new FormData(form);
    if (form.querySelector('[data-review-submit-stars]') && !validateFormData(formDataCheck)) {
      setFeedback(modal, i18n.validationError, false);
      return;
    }

    const payload = buildJsonPayload(form, modal);
    if (!payload) {
      setFeedback(modal, i18n.success, true);
      form.reset();
      return;
    }
    if (payload.invalid) {
      setFeedback(modal, i18n.validationError, false);
      return;
    }

    if (!apiBase) {
      setFeedback(modal, i18n.submitError, false);
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = i18n.sending || defaultLabel;
    }

    try {
      const data = await postJsonComment(apiBase, payload.shop, payload, i18n.submitError);
      setFeedback(modal, data.message || i18n.success || '', true);
      form.reset();
      resetProductFormUi(form);
    } catch (error) {
      setFeedback(modal, error.message || i18n.submitError || '', false);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = defaultLabel;
      }
    }
  };

  const bindModal = (modal) => {
    if (modal.dataset.reviewSubmitBound === 'true') {
      return;
    }

    const form = modal.querySelector('[data-review-submit-form]');
    const i18n = parseI18n(modal);

    modal.querySelectorAll('[data-review-submit-close]').forEach((el) => {
      el.addEventListener('click', () => {
        closeModal(modal);
      });
    });

    if (form) {
      bindStarRating(form);
      bindFileInput(form);
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        submitForm(modal, form, i18n);
      });
    }

    modal.dataset.reviewSubmitBound = 'true';
  };

  const bindOpenTriggers = () => {
    document.querySelectorAll('[data-review-submit-open]').forEach((trigger) => {
      if (trigger.dataset.reviewSubmitOpenBound === 'true') {
        return;
      }
      trigger.addEventListener('click', () => {
        const modal = getModalById(trigger.dataset.reviewSubmitOpen);
        openModal(modal);
      });
      trigger.dataset.reviewSubmitOpenBound = 'true';
    });
  };

  const init = () => {
    document.querySelectorAll('[data-review-submit-modal]').forEach(bindModal);
    bindOpenTriggers();
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }
    const openModalEl = document.querySelector('[data-review-submit-modal]:not([hidden])');
    if (openModalEl) {
      closeModal(openModalEl);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
